<template>
  <div id='roleAdd'>
    <!-- 个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="roleRow" :rules="rules" ref="roleRow">
      <fieldset style="border-width: 2px; border-color: #990000;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="roleName" id="roleName">
              <el-input v-model="roleRow.roleName" placeholder="请输入内容" style="width: 400px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="yczw">*</span>
            <el-form-item label="描述" prop="roleDesc" id="roleDesc">
              <el-input type="textarea" :rows="2" v-model="roleRow.roleDesc" placeholder="请输入内容" style="width: 400px;">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="yczw">*</span>
            <el-form-item label="类型" prop="roleType" id="roleType">
              <el-select v-model="roleRow.roleType" placeholder="请选择" style="width: 70%">
                <el-option v-for="item in typeList" :key="item.code" :label="item.value" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>

    <!-- 功能按钮 -->
    <el-row style="margin-top:15px">
      <el-col :span="20">&nbsp;
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="" v-show="false">关闭</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="save" @click='save'>保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    mounted: function () {
    },
    props:["roleRow"],
    data() {
      return {
        // 测试验证
        rules: {
          roleName: [{
            required: true,
            message: '请填写角色名称',
            trigger: 'blur'
          }],
        },
        typeList: [],
      }
    },
    mounted() {
      this.typeList = this.CommonUtil.getCodeList("role_type");
    },
    methods: {
      reset: function() {
        this.$refs["roleRow"].resetFields();
        this.$emit("closeEdit");
      },
      // 保存
      save: function () {
        this.$refs['roleRow'].validate((valid) => {
          if (valid) {
            this.$axios.post('/role/roleSave', this.roleRow).then((response) => {
              if(response.code != '0000'){
                this.$message({
                  message: response.message,
                  type: 'warning'
                });
              }else{
                this.$message({
                  message: response.message,
                  type: 'success'
                });
                this.reset();
                this.$emit("closeRole");
              }

            })
          }
        });
      }
    }
  }
</script>
<style scoped>
  div {
    margin-top: 0px;
  }

  .c {
    margin-top: 10px;
  }
  .yczw{
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/role/role.vue